import './Navbar.css';
import React,  { useState } from 'react';
import '../images/logo.png';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import img from '../images/logo.png';

const Navbar = () => {
    const [click, setClick] = useState(false);
    /* eslint-disable */
    function handleClick () {
        setClick(!click);
    }
    /* eslint-enable */
    /* eslint-disable */

    const [color, setColor] = useState(false);
    const changeColor = () => {
        if(window.screenY >=100){
            setColor(true);
        }else{
        setColor(false);
        }
    };
    /* eslint-enable */
    window.addEventListener("scroll", changeColor);

    return (
    <div className={color ? "Header Header-bg" : "Header"}>
        <Link to="/">
    <img className='header-img' src={img} alt="logo" width={100} height={100}/>
        </Link>
        <ul className={click ? "Navbar-menu active" : "Navbar-menu"}> 
            <li>
                <Link to="/">
                    <h6 className=' fs-5'>Home</h6></Link>
            </li>
            <li>
                <Link to="/project">
                    <h6 className=' fs-5'>Project</h6></Link>
            </li>
            <li>
                <Link to='/pay'>
                <h6 className='fs-5'>Pay</h6>
                </Link>
            </li>
            <li>
                <Link to="/news">
                    <h6 className=' fs-5'>News</h6></Link>
            </li>
            <li>
                <Link to="/about">
                    <h6 className=' fs-5'>About</h6></Link>
            </li>
            <li>
                <Link to="/contact">
                    <h6 className=' fs-5'>Contact</h6></Link>
            </li>
        </ul>
        <div className="hamburger" onClick={handleClick}>
            {click ? (<FaTimes size={20} style={{color: "#fff"}}/>) : (
            <FaBars size={20} style={{color: "#fff"}}/>)
            }
        </div>
    </div>
    );
};

export default Navbar